var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClassroomSpace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 55,
    fill: "none",
    viewBox: "0 0 37 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21.69,
    height: 6.585,
    x: 8.885,
    y: 7.359,
    fill: "#D9D9D9",
    rx: 3.292
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 14.331,
    height: 6.585,
    x: 0.364,
    y: 15.106,
    fill: "#D9D9D9",
    rx: 3.292
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 14.331,
    height: 6.585,
    x: 0.364,
    y: 29.049,
    fill: "#D9D9D9",
    rx: 3.292
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 14.331,
    height: 6.585,
    x: 0.364,
    y: 42.606,
    fill: "#D9D9D9",
    rx: 3.292
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 14.331,
    height: 6.585,
    x: 22.054,
    y: 15.106,
    fill: "#D9D9D9",
    rx: 3.292
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 14.331,
    height: 6.585,
    x: 22.054,
    y: 29.049,
    fill: "#D9D9D9",
    rx: 3.292
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 14.331,
    height: 6.585,
    x: 22.054,
    y: 42.606,
    fill: "#D9D9D9",
    rx: 3.292
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.73,
    cy: 2.711,
    r: 2.711,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.85,
    cy: 25.176,
    r: 2.711,
    fill: "#D9D9D9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.85,
    cy: 38.732,
    r: 2.711,
    fill: "#D9D9D9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.85,
    cy: 52.289,
    r: 2.711,
    fill: "#D9D9D9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.315,
    cy: 25.176,
    r: 2.711,
    fill: "#D9D9D9"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.315,
    cy: 38.732,
    r: 2.711,
    fill: "#D9D9D9"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.315,
    cy: 52.289,
    r: 2.711,
    fill: "#D9D9D9"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.435,
    cy: 25.176,
    r: 2.711,
    fill: "#D9D9D9"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.435,
    cy: 38.732,
    r: 2.711,
    fill: "#D9D9D9"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.435,
    cy: 52.289,
    r: 2.711,
    fill: "#D9D9D9"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.899,
    cy: 25.176,
    r: 2.711,
    fill: "#D9D9D9"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.899,
    cy: 38.732,
    r: 2.711,
    fill: "#D9D9D9"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.899,
    cy: 52.289,
    r: 2.711,
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassroomSpace);
export default __webpack_public_path__ + "static/media/classroom-space.9283649803a4f055468aec590358bf94.svg";
export { ForwardRef as ReactComponent };